import { useTheme } from '@material-ui/core/styles';

export const getArguments = (paramCount, theme, props) => {
  if (paramCount > 1) {
    return [theme, props];
  }

  if (paramCount === 1) {
    return props ? [props] : [theme];
  }
};

export const applyCallback = (callback, theme, props) => {
  const parameterCount = callback.length;
  const args = getArguments(parameterCount, theme, props);
  return callback.apply(null, args);
};

/**
 * Curries a function and returns a react hook.
 * The hook returns the value of the style object or the style object from the callback function
 * @param {Object} cssConfig - An style object
 * @param {function(object, object): object} cssConfig - A callback function to allow access to the theme or props that returns a style object.
 */
const makeCss = (cssConfig) => (props) => {
  const theme = useTheme();
  return typeof cssConfig === 'function'
    ? applyCallback(cssConfig, theme, props)
    : cssConfig;
};

export default makeCss;
